const updates = [
  {
    date: '2026-07-30',
    title: '2026全国街舞大赛总决赛结果揭晓',
    desc: '经过激烈角逐，全国街舞大赛总决赛于昨晚落下帷幕，冠军作品以极具创意的编舞和完美的舞台表现力征服评委。',
    tag: '赛事结果',
  },
  {
    date: '2026-07-29',
    title: '原创音乐大赛增设AI音乐创作赛道',
    desc: '为顺应技术趋势，本年度原创音乐大赛新增AI辅助创作赛道，允许参赛者使用AI工具进行音乐创作。',
    tag: '赛制更新',
  },
  {
    date: '2026-07-28',
    title: '短视频创作大赛周榜更新',
    desc: '本周短视频创作大赛热门作品榜单已更新，创意短剧和特效视频成为本周最大亮点。',
    tag: '榜单更新',
  },
  {
    date: '2026-07-27',
    title: '国际Cosplay大赛中国区报名开启',
    desc: '年度最受期待的国际Cosplay大赛中国赛区正式启动报名，预计将有超过500名选手参赛。',
    tag: '报名开启',
  },
  {
    date: '2026-07-26',
    title: '全国大学生摄影大赛作品展即将开幕',
    desc: '获奖作品线下展览将于8月初在北上广深四城同步开展，线上作品集同步上线每日大赛入口。',
    tag: '展览预告',
  },
  {
    date: '2026-07-25',
    title: 'AI创意设计挑战赛首轮评审完成',
    desc: '评审团从海量参赛作品中筛选出50件入围作品进入复赛，每日大全已同步更新入围名单。',
    tag: '评审进度',
  },
  {
    date: '2026-07-24',
    title: '美食大赛新增分子料理专项赛道',
    desc: '每日大赛类型中的美食赛道持续丰富，新增分子料理专项赛，吸引了一批先锋厨师参与。',
    tag: '赛道扩展',
  },
  {
    date: '2026-07-23',
    title: '编程竞赛平台升级完成',
    desc: '在线编程大赛平台完成升级，新增实时排行榜和代码回放功能，提升参赛和观赛体验。',
    tag: '平台升级',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading text-center mb-3">
          最新动态
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          每日大赛入口快讯，第一时间了解各大每日大赛最新进展
        </p>

        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-200"></div>
          <div className="space-y-6">
            {updates.map((item, i) => (
              <div key={i} className="relative flex gap-5 pl-12">
                <div className="absolute left-[11px] top-1.5 w-[17px] h-[17px] rounded-full border-[3px] border-primary-400 bg-background-50"></div>
                <div className="flex-1 rounded-xl border border-background-200/70 bg-background-50 p-4 md:p-5 cursor-pointer transition-colors hover:bg-background-100">
                  <div className="flex flex-wrap items-center gap-2 mb-2">
                    <span className="text-xs text-foreground-400">{item.date}</span>
                    <span className="inline-block px-2 py-0.5 rounded-full text-xs font-medium bg-secondary-100 text-secondary-700">
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}